import http from "./http-common"
import {Role} from "../types/domain";

/**
 * Service class for the Role type
 * @author NSC
 */
class RoleService {
    url = `/roles/`;

    getAll() {
        return http.get<Array<Role>>(this.url + `getAll`);
    }
}

export default new RoleService();